<template>
  <path
    d="M19.35 10.0402C18.67 6.59024 15.64 4.00024 12 4.00024C9.11 4.00024 6.6 5.64024 5.35 8.04024C2.34 8.36024 0 10.9102 0 14.0002C0 17.3102 2.69 20.0002 6 20.0002H19C21.76 20.0002 24 17.7602 24 15.0002C24 12.3602 21.95 10.2202 19.35 10.0402ZM19 18.0002H6C3.79 18.0002 2 16.2102 2 14.0002C2 11.7902 3.79 10.0002 6 10.0002H6.71C7.37 7.69024 9.48 6.00024 12 6.00024C15.04 6.00024 17.5 8.46024 17.5 11.5002V12.0002H19C20.66 12.0002 22 13.3402 22 15.0002C22 16.6602 20.66 18.0002 19 18.0002Z"
  />
</template>
